// Transparent Header
let header = document.getElementById('header');

function transparentHeader(){
    if(window.innerWidth >= 991){
        let headerHeight = header.scrollHeight;
        let scroll = window.scrollY;
        if(scroll > headerHeight){ header.classList.contains('ctm_trans_header') ? header.classList.remove('ctm_trans_header') : '' }
        else{ header.classList.contains('ctm_trans_header') ? '' : header.classList.add('ctm_trans_header') }
    }
}

transparentHeader(); 
document.addEventListener('scroll', transparentHeader );

// Before After
document.querySelectorAll('.ctm_beforeAfter .slider').forEach( (elm => { 
    elm.addEventListener('input', (e) => { e.target.closest('.ctm_beforeAfter--container').style.setProperty('--position', `${e.target.value}%`)     })
}))
